import Vue from 'src/views/base'
import { Component, Watch } from 'vue-property-decorator'
import template from './activation.vue'
import { Store as UserStore } from 'store/modules/user'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'
import newHeader from 'src/views/components/new-header'

@Component({
    name: 'activation',
    mixins: [template],
    components: {
        newHeader
    }
})
export default class UserActivation extends Vue {
    @UserStore.getter('userInfo') userInfo
    @UserStore.getter('redirectUrl') redirectUrl
    second = 3

    tips = null
    icon = null
    color = null
    redirectText = ''
    
    mounted() {
    }
    
    created () {
        this.handleAutomicTextActivation()
    }

    get hasBindMobile() {
        return !this.utils.isEmpty(this.userInfo.mobile)
    }

    get hasBindEmail() {
        return !this.utils.isEmpty(this.userInfo.email)
    }

    handleVerifyEmail() {
        this.goTo('/user/bind-email')
    }

    handleVerifyMobile() {
        this.goTo('/user/bind-mobile')
    }

    @Watch('userInfo', {
        deep: true,
        immediate: true
    })
    handleWatchUserInfo(val) {
        if (val.userStatus === 0) {
            this.tips = '您的账号处于【未激活】状态'
            this.icon = 'warning'
            this.color = '#F64A33'
        }
    }

    @Watch('$route', {
        deep: true,
        immediate: true
    })
    handleWatchRoute(route) {
        if (route.params && route.params.success) {
            this.tips = '账号注册成功'
            this.icon = 'success'
            this.color = '#31A400'
        }
    }
    handleAutomicTextActivation() {
        this.redirectText = `初始密码为手机号码后六位，${this.second}秒后将自动登录`
        let timer = setInterval(() => {
            this.second--
            this.redirectText = `初始密码为手机号码后六位，${this.second}秒后将自动登录`
            if (this.second === 0) {
                clearInterval(timer)
                this.passwordLogin()
            }
        }, 1000)
    }

    passwordLogin() {
        const params = {
            username: this.$route.params.username,
            password: this.$route.params.password,
            clienttype: '0'
        }
        this.api.userApi.login(params).then((data) => {
            if (data.code === 200) {
                // Cookies.set('lz_token', data.result.access_token, { expires: 3, domain: this.config.api.domain })
                // // this.toLZY(data.result.access_token)
                // location.href = `${this.config.api.LZY}/#/board?token=${data.result.access_token}`

                // 如果有重定向地址则跳转到重定向地址
                const redirectUrl = this.redirectUrl
                if (redirectUrl) {
                    location.href = decodeURIComponent(redirectUrl + `?token=${data.result.access_token}`)
                } else {
                    Cookies.set('lz_token', data.result.access_token, { expires: 3, domain: this.config.api.domain })
                    location.href = `${this.config.api.LZY}/#/board?token=${data.result.access_token}`
                }
            } else {
                Message({
                    message: data.message || '网络错误',
                    type: 'error'
                })
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/activation/index.js